<button
  aria-label="Expand or collapse"
  mat-icon-button
  (click)="onClickToggle()"
>
  @if (!isExpanded) {
    <mat-icon>expand_more</mat-icon>
  }
  @if (isExpanded) {
    <mat-icon>expand_less</mat-icon>
  }
</button>
